<template>
  <main-container v-if="isBasicRoute">
    <a-card>
      <a-table row-key="create_time" :loading="loading" :columns="columns" :data-source="dataSource">
        <template slot="service" slot-scope="record">
          <template v-for="val in record.service">
            <span>{{ val }}</span> <br />
          </template>
        </template>
        <template slot="action" slot-scope="record">
          <router-link :to="{ name: $routeName.servicePriceList, query: { type: record.type } }">查看详情 </router-link>
          <a-button
            type="link"
            @click="
              dialog = true;
              detail = record;
            "
            >更新</a-button
          >
        </template>
      </a-table>
    </a-card>
    <!-- 编辑路线弹窗 -->
    <EditModal :show="dialog" :detail="detail" @success="loadUserList()" @close="dialog = false" />
  </main-container>
  <router-view v-else></router-view>
</template>

<script>
import Service from '@/api/service';

import EditModal from './editModal.vue';
const columns = [
  {
    title: '来源公司',
    dataIndex: 'company',
  },
  {
    title: '物流服务',
    dataIndex: 'service_name',
  },
  {
    title: '路线',
    dataIndex: 'line',
  },
  {
    title: '路线服务',
    scopedSlots: { customRender: 'service' },
  },
  {
    key: 'action',
    title: '详情',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name: 'ServiceList',
  components: {
    EditModal,
  },
  data() {
    return {
      dialog: false,
      detail: {},
      columns,
      loading: false,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
      },
    };
  },

  computed: {
    isBasicRoute() {
      return this.$route.name === this.$routeName.serviceList;
    },
  },

  created() {
    this.loadUserList();
  },

  methods: {
    loadUserList() {
      this.loading = true;
      Service.serviceList({
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
